import React from "react";
import { useState, useEffect, useLayoutEffect } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { database } from './firebaseConfig';
import useFirebase from "./hooks/useFirebase";
import { Navigate, Route, Routes, useLocation, } from "react-router-dom";
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Admin from "./AdminPanel/AdminHome/Admin";
import AdminLogin from "./UserPanel/Pages/AdminLogin/AdminLogin";
import Home from "./UserPanel/Pages/Home/Home/Home";
import AuthProvider from './contexts/AuthProvider'
// import PrivateRoute from './PrivateRoute&init/PrivateRoute'
import './App.css';
import ManageComment from "./AdminPanel/ManageComment/ManageComment";
import Logos from "./AdminPanel/Logos/Logos";
import ManageOurProject from "./AdminPanel/ManageOurProjects/ManageOurProject";
// import OnGoingProject from "./UserPanel/Pages/Home/OnGoingProjects/OnGoingProject/OnGoingProject";
import ManageOnGoingProjects from "./AdminPanel/OnGoingProjects/ManageOnGoingProjects";
import ManageTeam from "./AdminPanel/ManageTeam/ManageTeam";
import Team from "./UserPanel/Pages/Team/Team";
import ProjectGallerys from "./UserPanel/Pages/ProjectGallery/ProjectGallerys/ProjectGallerys";
import ManageHomeBanner from "./AdminPanel/ManageHomeBanner/ManageHomeBanner";
import ProjectPhotos from "./AdminPanel/ProjectPhotos/ProjectPhotos";



function App() {

  const query1 = query(collection(database, "comments"));
  const [array, setArray] = useState([]);
  const query2 = query(collection(database, "logos"));
  const [array2, setArray2] = useState([]);
  const query3 = query(collection(database, "ourProjects"));
  const [array3, setArray3] = useState([]);
  const query4 = query(collection(database, "onGoingProjects"));
  const [array4, setArray4] = useState([]);
  const query5 = query(collection(database, "team"));
  const [array5, setArray5] = useState([]);
  const query6 = query(collection(database, "homeBanner"));
  const [array6, setArray6] = useState([]);



  const { user } = useFirebase();
  // const user = localStorage.getItem("user");
  const isLogedIn = Boolean(user?.email)


  useEffect(() => {

    const commentListener = onSnapshot(query1, (querySnapShot) => {
      const commentList = []
      querySnapShot.forEach((doc) => {
        commentList.push({ ...doc.data(), id: doc.id })
      })
      setArray(commentList)
    })

    const logoListener = onSnapshot(query2, (querySnapShot) => {
      const logoList = []
      querySnapShot.forEach((doc) => {
        logoList.push({ ...doc.data(), id: doc.id })
      })
      setArray2(logoList)
    })


    const projectListener = onSnapshot(query3, (querySnapShot) => {
      const projectList = []
      querySnapShot.forEach((doc) => {
        projectList.push({ ...doc.data(), id: doc.id })
      })
      setArray3(projectList)
    })


    const onGoingProjectListener = onSnapshot(query4, (querySnapShot) => {
      const onGoingProjectList = []
      querySnapShot.forEach((doc) => {
        onGoingProjectList.push({ ...doc.data(), id: doc.id })
      })
      setArray4(onGoingProjectList)
    })
    const teamListener = onSnapshot(query5, (querySnapShot) => {
      const teamList = []
      querySnapShot.forEach((doc) => {
        teamList.push({ ...doc.data(), id: doc.id })
      })
      setArray5(teamList)
    })
    const homeBannerListener = onSnapshot(query6, (querySnapShot) => {
      const bannerList = []
      querySnapShot.forEach((doc) => {
        bannerList.push({ ...doc.data(), id: doc.id })
      })
      setArray6(bannerList)
    })



    return (logoListener, projectListener, commentListener, onGoingProjectListener, teamListener, homeBannerListener);


  }, [])




  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children
  }
  return (
    <AuthProvider>
      <Wrapper>
        <Routes>

          <Route exact path="/" element={<Home comments={array} logos={array2} ourProjects={array3} onGoingProjects={array4} team={array5} banner={array6} />} />
          <Route exact path="/projectView/:id" element={<ProjectGallerys ourProjects={array3} />} />
          <Route exact path="/teamView" element={<Team team={array5} />} />
          {isLogedIn ? <Route path="/dashboard" element={<Admin />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}
          {!isLogedIn ? <Route path="/login" element={<AdminLogin />} /> : <Route path="*" element={<Navigate to="/dashboard" replace />} />}

          {isLogedIn ? <Route path="/Comments" element={<ManageComment comments={array} />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}
          {isLogedIn ? <Route path="/homeBanner" element={<ManageHomeBanner banner={array6} />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}

          {isLogedIn ? <Route path="/logos" element={<Logos logos={array2} />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}

          {isLogedIn ? <Route path="/onGoingProjects" element={<ManageOnGoingProjects onGoingProjects={array4} />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}

          {isLogedIn ? <Route path="/ourProjects" element={<ManageOurProject ourProjects={array3} />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}

          {isLogedIn ? <Route path="/projectPhotos/:id" element={<ProjectPhotos />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}

          {isLogedIn ? <Route path="/team" element={<ManageTeam team={array5} />} /> : <Route path="*" element={<Navigate to="/login" replace />} />}

          {isLogedIn ? <Route path="*" element={<Navigate to="/dashboard" replace />} /> : <Route path="*" element={<Navigate to="/" replace />} />}



        </Routes>
      </Wrapper>
    </AuthProvider>
  );
}

export default App;
